"use client";
import React from "react";
import { Cookie, Mail } from "lucide-react";

export default function CookiePolicyPage() {
  const appTitle = process.env.NEXT_PUBLIC_APP_TITLE;
  const contactEmail =  process.env.NEXT_PUBLIC_APP_EMAIL;
  const websiteUrl = process.env.NEXT_PUBLIC_APP_COMPANY_URL;
  
  return (
    <div className="bg-gray-50 lg:py-7">
      <div className="max-w-4xl mx-auto py-10 sm:py-16 px-4 sm:px-6 lg:px-8 bg-white shadow-lg lg:rounded-xl">
        
        {/* Title and Introduction */}
        <div className="mb-8 border-b pb-4 border-gray-200">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900">
            Cookie Policy
          </h1>
        </div>
        
        <p className="text-base sm:text-lg text-gray-700 mb-8 lg:mb-7 leading-relaxed"> 
          This Cookie Policy explains how we collect and use cookies when you as an end-user browse our website {websiteUrl}. We respect your privacy and understand your concern about the way your personal data is used. We ensure you of our commitment to protect the integrity and confidentiality of your personal information.
        </p>

        {/* --- What are Cookies? --- */}
        <h2 className="text-2xl font-bold text-gray-900 mb-4 pt-4 border-t border-gray-200">
          1. What are Cookies?
        </h2>
        <p className="text-base text-gray-700 mb-10 leading-relaxed">
Cookies are small pieces of data sent from a website and stored in a user&apos;s web browser while the user is browsing a particular website. Every time the user loads a website, the browser sends the cookie related to that website back to the website server to notify the website of the user’s previous activity on that website. They are often used as a mechanism by websites to remember activities that a website browser has done there in the past, for example, clicking on particular buttons, logging in, or having read pages on that site months or years ago.        </p>
        {/* --- How Offer County uses Cookies? (Key Terms box modified) --- */}
        <div className="bg-orange-50 p-6 sm:p-8 rounded-lg mb-10 border border-orange-100">
            <h2 className="text-xl font-bold text-orange-800 mb-4 flex items-center">
                <Cookie className="w-5 h-5 mr-2" />
                2. How {appTitle} uses Cookies
            </h2>
            <p className="text-base text-gray-700 mb-4 leading-relaxed">
                We use cookies to enhance your browsing experience, analyze the maximum visited/used areas of our website, and redefine what you see based on your activity. In general, we use the following types of cookies:
            </p>
            <ul className="list-disc pl-6 text-base text-gray-700 space-y-3">
              <li className="pl-1">Strictly Necessary Cookies: These are mandatory for our website to operate (e.g., enabling you to log into secure areas).</li>
              <li className="pl-1">Analytical/Performance Cookies: These help us identify and count the number of visits and quantify how visitors move around our website. This helps us improve our service.</li>
              <li className="pl-1">Functionality Cookies: We use these to improve the functional performance of our website, making it personalized for you (e.g., keeping you logged in or keeping your shopping cart).</li>
            </ul>
        </div>

        {/* --- What Happens with Social Networks? --- */}
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          3. What Happens with Social Networks?
        </h2>
        <p className="text-base text-gray-700 mb-10 leading-relaxed">
          If you &apos;share&apos; {appTitle} content with friends through social media like Facebook, Twitter, or other social networks, you may send cookies from these social media websites. We do not have any control over the settings of these cookies. Please check these social media websites for detailed information about their cookies and how to manage them. By using our website, you agree that we can place these types of cookies on your device.
        </p>
        
        {/* --- Managing Cookies --- */}
        <h2 className="text-2xl font-bold text-gray-900 mb-4 pt-4 border-t border-gray-200">
          4. Managing Cookies
        </h2>
        <p className="text-base text-gray-700 mb-4 leading-relaxed">
          You can manage cookies by changing or activating the setting on your web browser which would allow you to either accept or refuse the settings of some or all cookies.
        </p>
        <p className="text-base text-gray-700 mb-6 leading-relaxed">
          If you wish to manage your preferences regarding cookies, refer to online help files available using your web browser for detailed instructions. Alternatively, you can visit <a href="http://www.aboutcookies.org" target="_blank" rel="noopener noreferrer" className="text-primary-600 font-semibold hover:text-primary-700 underline transition-colors">http://www.aboutcookies.org</a> for further information.
        </p>
        <p className="text-base font-semibold text-red-700 bg-red-50 p-3 rounded-lg mb-10 border border-red-100 leading-relaxed">
          Please note: If you refuse to accept cookies from our website, you may not be able to use some additional features that the website offers. In fact, some areas of the website may not be accessible at all.
        </p>
        
        {/* Contact CTA */}
        <div className="text-base sm:text-lg text-gray-700 mt-10 pt-4 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <Mail className="w-5 h-5 mr-2 text-primary-600" />
                5. Contact Us
            </h2>
            <p className="mb-2">
                If you have any issues or concerns regarding this Cookie Policy, please contact us at:
            </p>
            <a href={`mailto:${contactEmail}`} className="text-primary-600 font-semibold hover:text-primary-700 underline transition-colors">
                {contactEmail}
            </a>
        </div>
      </div>
    </div>
  );
}